import Duck from 'custom-redux-ducks-ts'

export const abm = new Duck('abm', 'eduprivada')
